import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import React from 'react';
import Join from './public/Join';
import CreatePassword from './public/CreatePassword';
import Error404 from './comp/ui/404';
import BasePublic from './comp/HOC/BasePublic';

function RouterPublic() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BasePublic />}>
          <Route path="/join" element={<Join />} />
          <Route path="/create-password" element={<CreatePassword />} />
          <Route path="" element={<Navigate to="/join" />} />
          <Route path="*" element={<Error404 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default RouterPublic;
